import { wagmiConfig } from '@/config/wagmi-config'
import { NetworkId } from '@/types/network'
import { waitForTransactionReceipt as wagmiWaitForTransactionReceipt } from '@wagmi/core'

type Params =
	Parameters<typeof wagmiWaitForTransactionReceipt> extends [any, infer Params]
		? Params & { chainId?: NetworkId }
		: never

/**
 * Helper with pre-defined wagmi config
 */
export const waitForTransactionReceipt = (params: Params) => wagmiWaitForTransactionReceipt(wagmiConfig, params)
